<template>
  <div :class="{ 'multi-date__error': errorStart || errorEnd }" class="multi-date">
    <div :class="{ 'form-data__error': errorStart }" class="form-data">
      <div class="upper-label">{{ label }} / От</div>
      <date-picker v-model="start_date" :not-after="end_date" lang="ru" type="date" :disabled="disable" @change="keymonitor" />
    </div>
    <div class="holder" />
    <div :class="{ 'form-data__error': errorEnd }" class="form-data">
      <div class="upper-label">{{ label }} / До</div>
      <date-picker v-model="end_date" :not-before="start_date" lang="ru" type="date" :disabled="disable" @change="keymonitor" />
    </div>
    <div class="error-input-info">{{ errorInfo }}</div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "FormMultiDate",
  components: { DatePicker },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    serverError: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    },
    fieldname: {
      type: Object,
      default: () => ({})
    },
    errorStart: {
      type: Boolean,
      default: false
    },
    errorEnd: {
      type: Boolean,
      default: false
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    errorLabel: {
      type: String,
      default: ""
    },
    bottomInfo: {
      type: String,
      default: ""
    },
    errorInfo: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    start_date: {
      get() {
        return this.startDate;
      },
      set(newValue) {
        this.$emit("update", {
          value: this.getDate(newValue),
          fieldname: this.fieldname.startDate
        });
      }
    },
    end_date: {
      get() {
        return this.endDate;
      },
      set(newValue) {
        this.$emit("update", {
          value: this.getDate(newValue),
          fieldname: this.fieldname.endDate
        });
      }
    }
  },
  methods: {
    getDate(d1) {
      const d = new Date(d1);
      const month = `0${d.getMonth() + 1}`;
      const date = `0${d.getDate()}`;
      return `${d.getFullYear()}-${month.slice(-2)}-${date.slice(-2)}`;
    }
  }
};
</script>
